import React from 'react';
import { useMemo } from 'react';
import Icon from '../Icon';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { breakpoint } from '../../styling/mixins/breakpoints';

interface StyledMiniCartIconProps {
  addToCartAnimating: boolean;
}

const StyledMiniCartIcon = styled.div`
  position: relative;
  color: ${getColor('grey', 900)};
`;

const StyledQuantity = styled.div<StyledMiniCartIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: ${getColor('white')};
  text-align: center;
  position: absolute;
  top: -1px;
  right: -4px;
  width: 10px;
  height: 10px;
  transition: 0.125s ease-in-out;
  -moz-transition: 0.125s ease-in-out;
  -webkit-transition: 0.125 ease-in-out;
  border-radius: 100%;
  line-height: 1.3;
  transform: ${(props) => (props.addToCartAnimating ? 'scale(1.5)' : null)};
  background-color: ${(props) =>
    props.addToCartAnimating
      ? getColor('primary', 500)
      : getColor('primary', 500)};
  
  ${breakpoint('large')} {
    ${text('small')};
    top: -2px;
    width: 16px;
    height: 16px;
}
`;

const MiniCartIcon = ({ iconClassName }: { iconClassName?: string }) => {
  const { orderRows, addToCartAnimating = false } = useTypedSelector(
    (state) => state.cart
  );

  const quantity = useMemo(
    () =>
      Math.min(
        orderRows.reduce((prev, current) => prev + current.quantity, 0),
        99
      ),
    [orderRows]
  );

  return (
    <StyledMiniCartIcon>
      <Icon name="shopping-cart" className={iconClassName} />
      {quantity > 0 ? (
        <StyledQuantity addToCartAnimating={addToCartAnimating}>
          {quantity}
        </StyledQuantity>
      ) : null}
    </StyledMiniCartIcon>
  );
};

export default MiniCartIcon;
